module.exports = __webpack_public_path__ + "img/vard1.3d7022fd.png";